import { render } from "./AdPlacementTypeTableItem.vue?vue&type=template&id=5d6f331f"
import script from "./AdPlacementTypeTableItem.vue?vue&type=script&lang=js"
export * from "./AdPlacementTypeTableItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__